<template>
  <!--footer-->
  <div class="radio_group flex-c">
    <template v-for="(item, i) in list">

      <template v-if="!hidden.includes(item.value)">
        <template v-if="disable === false">
          <div :key="i" class="radio_item" @click="chooseItem(item)" :class="value==item.value?'checked':''">
            {{item.title}}
          </div>
        </template>

        <template v-else>
          <div :key="i" class="radio_item disable">
            {{item.title}}
          </div>
        </template>
      </template>

    </template>

  </div>
  <!--footer end-->
</template>

<script>
export default {
  name: 'radioGroup',
  props: {
    list: {
      type: Array,
      default: [],
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    }, // 禁用
    hidden: {
      type: Array,
      default: [],
    }, //隐藏对应
  },
  data () {
    return {

    }
  },
  methods: {
    chooseItem(item){
      this.$emit('update:value', item.value)
      this.$emit('update:label', item.title)
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/components/radio_group.vue